export const DEFAULT_IMAGE_CONTAINER = { width: 50, height: 50 };
